import React from 'react';
import { XIcon } from 'lucide-react';
export const DocumentModal = ({
  document,
  onClose
}) => {
  if (!document) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-441">
      <div className="bg-white rounded-lg w-full max-w-4xl mx-4 h-[80vh] flex flex-col" data-id="element-442">
        <div className="flex justify-between items-center p-6 border-b" data-id="element-443">
          <h2 className="text-xl font-semibold" data-id="element-444">{document.title}</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-445">
            <XIcon className="h-6 w-6" data-id="element-446" />
          </button>
        </div>
        <div className="flex-1 p-6 overflow-auto" data-id="element-447">
          {document.type === 'pdf' && <iframe src={document.url} className="w-full h-full" title={document.title} data-id="element-448" />}
          {document.type === 'video' && <video src={document.url} controls className="w-full h-full" data-id="element-449" />}
          {document.type === 'presentation' && <iframe src={document.url} className="w-full h-full" title={document.title} data-id="element-450" />}
        </div>
      </div>
    </div>;
};